"use strict";
/**
 * Contact Management Type Definitions
 * System-internal contact management for DFFiles
 *
 * Requirements: 14.1, 14.2, 14.3, 17.1, 17.4
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactValidation = void 0;
// CR-041: メール正規表現はプロジェクト全体で唯一の定義（utils/validation）を参照する
const validation_1 = require("../utils/validation");
// ============================================================================
// Validation Rules (Constants)
// ============================================================================
/**
 * Contact validation rules
 */
exports.ContactValidation = {
    NAME_MIN_LENGTH: 1,
    NAME_MAX_LENGTH: 100,
    EMAIL_REGEX: validation_1.EMAIL_REGEX, // CR-041: utils/validation の唯一定義を参照（強化版）
    ORGANIZATION_MAX_LENGTH: 200,
    MEMO_MAX_LENGTH: 1000,
    MAX_CONTACTS_PER_USER: 500,
    DEFAULT_PAGE_LIMIT: 50,
    MAX_PAGE_LIMIT: 100,
};
//# sourceMappingURL=contact.js.map